import { apiClient } from 'modules/core/lib/mobx-rest'

import Survey from 'modules/surveys/store/models/v2/Survey'

const getCurrentClimate = async () => {
  const api = apiClient()
  const result = await api.get('/surveys/v2/surveys/current_climate_survey')
  if (!!result && !!Object.keys(result).length) {
    return new Survey(result)
  }
}

export default getCurrentClimate
